import type { SampleOrderLinkFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type {
  GTMEventGlycerinDisplayLink,
  GTMEventGlycerinDisplayOverlay,
  GTMEventGlycerinFormSubmitClick,
} from '@packages/tracking/src/types/events';
import { getSampleOrderGlycerinDetail } from '../../helper/getSampleOrderGlycerinDetail/getSampleOrderGlycerinDetail';

const category = 'SampleOrder';

export const useSampleOrderTracking = () => {
  const dispatchTracking = useTracking();

  const trackSampleOrderClick = (
    sampleOrderType: SampleOrderLinkFragmentFragment['sampleOrderType'],
  ) => {
    dispatchTracking<GTMEventGlycerinDisplayOverlay>({
      event: 'DisplayOverlay',
      DisplayOverlayData: {
        category,
        detail: getSampleOrderGlycerinDetail(sampleOrderType),
      },
    });
  };

  const trackSampleOrderSeen = (
    sampleOrderType: SampleOrderLinkFragmentFragment['sampleOrderType'],
  ) => {
    dispatchTracking<GTMEventGlycerinDisplayLink>({
      event: 'DisplayLink',
      DisplayLinkData: {
        category,
        detail: getSampleOrderGlycerinDetail(sampleOrderType),
        target: 'Overlay',
      },
    });
  };
  const trackSampleOrderSubmit = (
    sampleOrderType: SampleOrderLinkFragmentFragment['sampleOrderType'],
  ) => {
    dispatchTracking<GTMEventGlycerinFormSubmitClick>({
      event: 'FormSubmitClick',
      FormSubmitClickData: {
        category,
        detail: getSampleOrderGlycerinDetail(sampleOrderType),
      },
    });
  };

  return {
    trackSampleOrderClick,
    trackSampleOrderSeen,
    trackSampleOrderSubmit,
  };
};
